// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3ueS3","card":"Cards_card__h2mcF","infected":"Cards_infected__3eQRN","recovered":"Cards_recovered__2EpqE","deaths":"Cards_deaths__31pCC"};